module.exports = __webpack_public_path__ + "img/logo15.542bee1b.jpg";